import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { erpIntegrationService } from '../../../services/erpIntegrationService';

const AuditLogPanel = ({ connection }) => {
  const [auditLogs, setAuditLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (connection?.id) {
      loadAuditLogs();
    }
  }, [connection]);

  const loadAuditLogs = async () => {
    try {
      setLoading(true);
      const data = await erpIntegrationService?.getAuditLogs(connection?.id, 50);
      setAuditLogs(data);
    } catch (error) {
      console.error('Error loading audit logs:', error);
    } finally {
      setLoading(false);
    }
  };

  const getActionIcon = (actionType) => {
    const icons = {
      connection_created: 'Link',
      sync_started: 'RefreshCw',
      mapping_updated: 'GitBranch',
      conflict_resolved: 'CheckCircle',
      connection_updated: 'Settings',
      sync_completed: 'Check'
    };
    return icons?.[actionType] || 'FileText';
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-foreground mb-1">Audit Trail</h2>
        <p className="text-sm text-muted-foreground">
          Complete audit log for {erpIntegrationService?.getERPSystemLabel(connection?.erpSystem)}
        </p>
      </div>

      {loading ? (
        <div className="text-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading audit logs...</p>
        </div>
      ) : (
        <div className="bg-background border border-border rounded-lg">
          <div className="divide-y divide-border">
            {auditLogs?.map((log) => (
              <div key={log?.id} className="p-5 hover:bg-muted/50 transition-colors">
                <div className="flex items-start gap-4">
                  <div className="bg-primary/10 text-primary p-2 rounded-lg">
                    <Icon name={getActionIcon(log?.actionType)} size={20} />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-2">
                      <div>
                        <h4 className="font-medium text-foreground">{log?.actionDescription}</h4>
                        <p className="text-sm text-muted-foreground mt-1">
                          Action: {log?.actionType?.replace('_', ' ')}
                        </p>
                      </div>
                      <span className="text-xs text-muted-foreground">
                        {new Date(log?.performedAt)?.toLocaleString()}
                      </span>
                    </div>
                    <div className="flex items-center gap-4 text-sm text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <Icon name="User" size={14} />
                        {log?.performedBy}
                      </span>
                      {log?.entityType && (
                        <span className="flex items-center gap-1">
                          <Icon name="Database" size={14} />
                          {log?.entityType}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditLogPanel;
